//Generated File 
export default class PreferencesRequest{
	static readonly EDIT_LAYOUT = `editLayout`;
	static readonly LIST_LAYOUT = `listLayout`;
	static readonly LIST_LAYOUT_PREFERENCES = `listLayoutPreferences`;
	static readonly META_DATA = `metaData`;
	static readonly SEARCHER_LAYOUT = `searcherLayout`;
	static readonly VIEW_NAMES = `viewNames`;
}
